export default [
  "404",
  "loading",
  "all-routes",
  "access-denied",
  "company",
  "maintenance",
  "features",
  "landing",
  "manifesto",
  "privacy",
  "privacy-policy",
  "project",
  "reset-password",
  "signin",
  "signout",
  "signup",
  "creator",
  "publisher",
  "seek-opportunities",
  "start",
  "successful-experience",
  "termsofservice",
  "contractor-agreement",
  "master-publisher-agreement",
  "terms-update",
  "verify-email",
  "account",
  "admin",
  "reports",
  "complaint-policy",
  "copyright-policy",
  "messages",
  "settings",
  "people",
  "posting",
  "postings",
  "wizard",
  "projects",
  "upgrade",
  "out"
]
;